import StatusField from "components/StatusField";
import React, { cloneElement } from "react";
import {
  Datagrid,
  Filter,
  ReferenceField,
  ResourceContextProvider,
  sanitizeListRestProps,
  SearchInput,
  TextField,
  TopToolbar,
  useListContext,
  Button,
  ShowProps,
  RowClickFunction,
} from "react-admin";
import IconPlus from "@material-ui/icons/Add";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomArrayChipField from "components/CustomArrayChipField";
import BooleanChipField from "components/BooleanChipField";
import { PaddingDenseStyled2List } from "../../components/ListWrapper";
import CustomPagination from "../../components/CustomPagination";

const ThisFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const ListActions = (props: any) => {
  const { className, exporter, filters, maxResults, history, ...rest } = props;
  const { resource, displayedFilters, filterValues, showFilter } =
    useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}

      <Button
        onClick={() =>
          history.push(
            `/levels/create?source=${JSON.stringify({
              schoolId: Number(props.filterValues?.SchoolId),
            })}&schoolId=${Number(props.filterValues?.SchoolId)}`
          )
        }
        label="Create Level"
      >
        <IconPlus />
      </Button>
    </TopToolbar>
  );
};

const LevelAndClass = (props: ShowProps) => {
  const rowClick: RowClickFunction = (id, basePath, record) =>
    `/levels/${id}/show?schoolId=${Number(record.schoolId)}`;

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Levels</Typography>
      </Grid>
      <Grid item xs={12}>
        <ResourceContextProvider value="levels">
          <PaddingDenseStyled2List
            {...props}
            exporter={false}
            hasCreate={false}
            filters={<ThisFilter {...props} />}
            filterDefaultValues={{
              SchoolId: parseInt(props.id),
            }}
            bulkActionButtons={false}
            title=" "
            actions={<ListActions history={props.history} />}
            pagination={<CustomPagination />}
          >
            <Datagrid rowClick={rowClick}>
              <TextField source="name" label="Level" emptyText="-" />
              <ReferenceField
                source="nextLevelId"
                reference="levels"
                label="Next Level"
                emptyText="-"
              >
                <TextField source="name" />
              </ReferenceField>
              <CustomArrayChipField
                label="Class"
                source="levelGroups"
                chipSource="name"
              />
              <StatusField source="status" />
              <BooleanChipField source="dropOffAuth" />
            </Datagrid>
          </PaddingDenseStyled2List>
        </ResourceContextProvider>
      </Grid>
    </SanitizedGrid>
  );
};

export default LevelAndClass;
